import classNames from 'classnames';
import React from 'react';
import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useCtx } from '..';
import s from '../Canvas/styles.module.css.json';
import { generateStyleFromCtx } from '../generateStyleFromCtx';
export function Portal(_a) {
    var children = _a.children;
    var ctx = useCtx();
    var elRef = useRef(typeof document === 'undefined' ? null : document.createElement('div'));
    useEffect(function () {
        if (!elRef.current || !document.body) {
            return;
        }
        document.body.appendChild(elRef.current);
        return function () {
            if (elRef.current) {
                document.body.removeChild(elRef.current);
            }
        };
    }, []);
    if (!elRef.current) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement("div", { className: classNames(s.themeVariables, s.canvas), style: generateStyleFromCtx(ctx, true) }, children), elRef.current);
}
//# sourceMappingURL=Portal.js.map